import type { Room } from "livekit-client";

const participantTokens = new WeakMap<Room, string>();

export function rememberLiveKitRoomParticipantToken(room: Room, token: string): void {
  if (token) participantTokens.set(room, token);
}

export function getLiveKitRoomParticipantToken(room: Room): string | null {
  return participantTokens.get(room) || null;
}
